<div class="close-icon">
    <span>
        <svg>
            <use href="../App_Themes/CXone/icons/close.svg#close" id="delete-svg-icon"></use>
        </svg>
    </span>
</div>